import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative w-full bg-gradient-to-br from-slate-900 via-blue-900 to-teal-900 pt-12 pb-16 px-4 overflow-hidden" data-id="element-107">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-blue-500/20 rounded-full blur-[120px] pointer-events-none" data-id="element-108"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-teal-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-109"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-110">
        <h1 className="text-2xl md:text-3xl font-black text-white uppercase tracking-tight mb-4 leading-tight drop-shadow-lg" data-id="element-111">
          KIT DE APRENDIZAJE EN CASA
        </h1>

        <h2 className="text-base md:text-lg font-medium text-blue-100 mb-8 leading-snug max-w-2xl mx-auto" data-id="element-112">
          Las herramientas psicopedagógicas que necesitas para comprender y
          ayudar a tu hijo
        </h2>

        <div className="relative w-full max-w-2xl mx-auto mb-8" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/cFbzxh2xnRUhmS5x7yZrgw/Mockap_pricipal.png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-114" />
        </div>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 mb-8 max-w-3xl mx-auto shadow-2xl" data-id="element-115">
          <p className="text-lg md:text-xl font-semibold text-white mb-2" data-id="element-116">
            Descubre cómo ayudar a tu hijo cuando tiene dificultades para
            aprender, incluso si no sabes por dónde empezar.
          </p>
        </div>

        <div className="mt-8" data-id="element-117">
          <CTAButton text="👉 ACCEDER AHORA" data-id="element-118" />
        </div>
      </div>
    </section>;
}